export default "__VITE_ASSET__D4whNged__"